import { toast } from "react-toastify";
import { apiSlice } from ".";
import { logout, setAgent } from "../features/authSlice";

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    agentLogin: builder.mutation({
      query: (credentials) => ({
        url: "/agent/agentLogin",
        method: "POST",
        body: credentials,
      }),
    }),

    getAgent: builder.query({
      query: (agentId) => `/Agent/GetAgentTable/${agentId}`,
      providesTags: ["Agent"],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data: agent } = await queryFulfilled;
          if (agent && agent.length === 0) {
            dispatch(logout());
          }
          dispatch(setAgent(agent[0]));
        } catch {
          dispatch(logout());
        }
      },
    }),

    editAgent: builder.mutation({
      query: (data) => ({
        url: `/Agent/PutAgentTable/${data.agentid}`,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["Agent"],

      async onQueryStarted(ars, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Upadting Profile",
          success: "Profile Updated",
          error: "Error Updating Profile",
        });
      },
    }),

    getAgents: builder.query({
      query: (agencyId) => `/Agent/GetAgentbyAgencyID/${agencyId}`,
    }),
    getAgentDashboard: builder.query({
      query: (data) => ({
        url: `/Dashboard/AgentDashboard?agtid=${data.agentId}&agcid=${data.agencyId}`,
      }),
    }),
    addAgent: builder.mutation({
      query: (data) => ({
        url: "/Agent/PostAgentTable",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        toast.promise(queryFulfilled, {
          pending: "Adding Staff",
          success: "Staff Added",
          error: "Error Adding Agent",
        });

        // const { data: agent } = await queryFulfilled;

        // dispatch(
        //   agentsApi.util.updateQueryData("getAgents", data.agencyid, (agents) => {
        //     agents.push(agent);
        //   })
        // );
      },
    }),
    addAgentLanguages: builder.mutation({
      query: (data) => ({
        url: `/languagelists/Postlanguagelist`,
        method: "POST",
        body: data,
      }),
      // invalidatesTags: ["Agents"],
    }),
    getAgencyDashboardTasks: builder.query({
      query: ({ agcId, agtId, recAgtId }) =>
        `/Dashboard/GetTaskCounts?agcid=${agcId}&senderid=${agtId}&recieverid=${recAgtId}`,
    }),
    getAgencyDashboardTasksStatuses: builder.query({
      query: ({ agcId, agtId, recAgtId }) =>
        `/Dashboard/GetTaskStatusBreakdown?senderid=${agtId}&agcid=${agcId}&recieverid=${recAgtId}`,
    }),
    getAgencyDashboardLeadsCount: builder.query({
      query: ({ agcId, agtId, fromDate, toDate }) =>
        `/Dashboard/GetLeadStatusCounts?agencyid=${agcId}&agentid=${agtId}&fromdate=${fromDate}&todate=${toDate}`,
    }),
    getAgencyDashboardPriority: builder.query({
      query: ({ agcId, agtId }) =>
        `/dashboard/GetLeadPriorityCounts?agencyid=${agcId}&agentid=${agtId}`,
    }),
    // to do Today api
    getDashboardToDoToday: builder.query({
      query: ({ today, agtId }) =>
        // Dashboard/Getodotoday?today={today}&agentid={agentid}
        `/Dashboard/Getodotoday?today=${today}&agentid=${agtId}`,
    }),

    //Employee Performance
    getAgencyDashboardEmployeePerformance: builder.query({
      query: ({ agcId, fromDate, toDate }) =>
        // Dashboard/GetAgentPerformance?agcid={agcid}&fromdate={fromdate}&todate={todate}
        `Dashboard/GetAgentPerformance?agcid=${agcId}&fromdate=${fromDate}&todate=${toDate}`,
    }),
    //overdue Api
    getAgencyDashboardOverdueCount: builder.query({
      query: ({ agcId, agtId, toDate }) =>
        `Dashboard/GetOverDueLeadStatusCounts?todate=${toDate}&agencyid=${agcId}&agentid=${agtId}`,
    }),
  }),
});

export const {
  useAgentLoginMutation,
  useGetAgentQuery,
  useEditAgentMutation,
  useGetAgentDashboardQuery,
  useLazyGetAgentQuery,
  useGetAgentsQuery,
  useGetAgencyDashboardTasksQuery,
  useGetAgencyDashboardTasksStatusesQuery,
  useGetAgencyDashboardLeadsCountQuery,
  useGetAgencyDashboardPriorityQuery,
  useAddAgentLanguagesMutation,
  useAddAgentMutation,

  useGetDashboardToDoTodayQuery,
  useGetAgencyDashboardOverdueCountQuery,
  useGetAgencyDashboardEmployeePerformanceQuery,
} = authApi;
